<section ngClass.gt-sm="large">
  <div class="dialog-title">
    <h2>{{data.title}}</h2>
  </div>
  <div class="mat-body dialog-message" mat-dialog-content fxLayoutGap="16px" fxLayout="column">
    <div
        class="container-form-inactive-user"
        fxLayout="row"
        fxLayoutGap="8px"
      >
        <mat-icon>warning</mat-icon>
        <div fxLayout="column" fxLayoutGap="2px">
          <h3 class="bold">
            {{ 'reset-password.currentWarningMessageTitle' | translate }}
          </h3>
          <span class="container-form-inactive-user-description">
            {{ 'reset-password.currentWarningMessage' | translate }}
          </span>
        </div>
      </div>
    <form class="width-100 height-100" fxLayout="column"
            fxLayoutAlign="flex-start center" fxLayoutGap="16px">
      <app-password-confirmation
        [passwordControl]="passwordControl"
        [confirmPasswordControl]="confirmPasswordControl"
        passwordLabel="reset-password.newPassword"
        confirmLabel="reset-password.confirmNewPassword"
      ></app-password-confirmation>
    </form>
  </div>
  <mat-toolbar
    fxLayout="row"
    fxLayoutAlign="flex-end flex-end"
    fxLayoutGap="20px"
    fxLayout.lt-sm="column"
    fxLayoutGap.lt-sm="12px"
    ngClass.lt-sm="mobile"
  >
    <button mat-stroked-button color="darkblue" [mat-dialog-close]="false">
      {{ data.cancel ? data.cancel  : ('common.cancel' | translate) }}
    </button>
    <button [disabled]="passwordControl.invalid || confirmPasswordControl.invalid" class="no-border filled" color="yellow" mat-stroked-button [mat-dialog-close]="true" (click)="savePassword()">
      {{ data.confirm ? data.confirm : ('common.save' | translate) }}
    </button>
  </mat-toolbar>
</section>
